module.exports = __webpack_public_path__ + "static/media/Stagecoach_LOGO_BLK_V2_x95@2x.b6a9be30.png";